import React from 'react';
import { OnboardingSetupPage } from 'src/legacy/components/Onboarding/OnboardingSetupPage';
import { RouterContext } from 'universal-router';

function action(context: RouterContext) {
  const isInternalUser = context.portalConfig.viewMode === 'internal';
  return {
    chunks: ['onboarding-setup'],
    ...(isInternalUser
      ? {
          description: 'Sign up for a Copilot account.',
          title: 'Copilot • Sign up',
        }
      : {}),
    component: <OnboardingSetupPage />,
  };
}

export default action;
